export var Size;
(function (Size) {
    Size["default"] = "default";
    Size["small"] = "small";
    Size["large"] = "large";
})(Size || (Size = {}));
